const INITIAL_TIMEOUT = 60000;

export class Emitter {
  constructor() {
    this.active = false;
    this.queue = [];
    setTimeout(() => this.emptyQueue(), INITIAL_TIMEOUT);
  }

  activate() {
    this.active = true;
    this.processQueue();
    this.emptyQueue();
  }

  callEvent(functionName, params) {
    if (typeof this[functionName] === 'function') {
      if (this.active) {
        this[functionName](params);
      } else {
        this.queue.push(() => this[functionName](params));
      }
    }
  }

  processQueue() {
    this.queue.forEach((fn) => fn());
  }

  emptyQueue() {
    this.queue = [];
  }
}
